import styled from 'styled-components';
export const MobileFilterPillsWrapper = styled.div`
  position: initial;
  margin-top: 10%;
  margin-bottom: 10%;
  display: flex;
  margin-right: 0;
  margin-bottom: 20px;
`;


export const MobileFilterPill = styled.span`
  border: 1px solid #000;
  box-shadow: none;
  font-size: 12px;
  cursor: pointer;
  padding: 5px 9px 5px 13px;
  margin-right: 0;
  font-weight: 300;
  display: flex;
  & img {
    padding: 0 0 0 10px;
  };
  background-color: white;
`;